import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { ComponentsComponent } from './components/components.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AboutComponent } from './components/about/about.component';
import { ContactComponent } from './components/contact/contact.component';
import { PrivacypolicyComponent } from './components/privacypolicy/privacypolicy.component';
import { SearchBurujuComponent } from './components/searchburuju/searchburuju.component';

const routes: Routes =[
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home',             component: ComponentsComponent},
    { path: 'news/:id',     component: ProfileComponent },
    { path: 'about',      component: AboutComponent },
    { path: 'contact',      component: ContactComponent },
    { path: 'privacypolicy',      component: PrivacypolicyComponent },
    { path: 'searchburuju',      component: SearchBurujuComponent },

];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: false,
      scrollPositionRestoration: 'enabled' //scroll to the top
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
